"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentManagementDefaultValue = exports.documentManagementSchema = void 0;
const zod_1 = require("zod");
exports.documentManagementSchema = zod_1.z.object({
    view: zod_1.z.union([zod_1.z.literal('self'), zod_1.z.literal('anyone')]),
    upload: zod_1.z.union([zod_1.z.literal('self'), zod_1.z.literal('anyone'), zod_1.z.literal('none')]),
    deletion: zod_1.z.union([zod_1.z.literal('self'), zod_1.z.literal('anyone'), zod_1.z.literal('none')]),
    approve: zod_1.z.boolean().optional(),
    mark_as_paid: zod_1.z.boolean().optional(),
    profiles_to_notify_on_upload: zod_1.z.array(zod_1.z.string()).optional(),
});
const defaultValue = {
    view: 'self',
    upload: 'self',
    deletion: 'self',
    approve: false,
    mark_as_paid: false,
    profiles_to_notify_on_upload: [],
};
exports.documentManagementDefaultValue = JSON.stringify(defaultValue, null, '\t');
